export const STATUS_LABEL = { invited: "Invité", active: "Actif", suspended: "Suspendu" };
export const STATUS_CLS = { invited: "bg-amber-500/15 text-amber-400", active: "bg-emerald-500/15 text-emerald-400", suspended: "bg-red-500/15 text-red-400" };
